module.exports = __webpack_public_path__ + "img/img000.ffa315a2.png";